<template>
  <div class="wy-smart-tag-dashboard-page-header">
    <table border="0" class="list-header" cellspacing="0" cellpadding="0">
      <tr style="display: flex; width: calc(100% - 2px); flex-direction: column;" valign="absmiddle">
        <td style="display: flex; justify-content: space-between;" class="col1">
          <div style="display:flex; height:35px; margin-top: 3px;">
            <div>
              <div class="title">AI Generated Tags</div>
              <div class="small-title">View how frequently tags apply to contacts.</div>
            </div>
            <div class="question-mark">
            </div>
          </div>
          
        </td>

        <td class="col3 table-header-middle">
          <div style="display: flex;align-items: center;">
            <wy-table-search :controller="controller" :searchFields="searchFields" v-if="!hideSearchColumnUI" 
            :dataTestIdSearchType="'AI-Tags-AiGeneratedTags-SearchBar-SearchType'" />
            <div v-if="!hideSearchColumnUI" class="search-label-prefix">By</div>
          </div>
          <div>
            
          </div>
          <div style="display: flex;align-items: center;">
            <wy-table-column v-if="!hideSearchColumnUI" ref="columnSelectionDropdown" :controller="controller" :dataTestId="'AiTags-AiGeneratedTags-Columns'" />
            <el-button class="export-btn" round @click="handleExport" :disabled="!enableExport" data-testid="AiTags-AiGeneratedTags-ExportButton">
              <div class="export-icon"></div>
              <span class="export-text">Export</span> 
            </el-button>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ObjectsToCsv from 'objects-to-csv';
import WyTableColumn from '../widgets/wy-table-column';
import WyTableSearch from '../widgets/wy-table-search-with-select';
// import wyPageTooltip from '../widgets/wy-page-tooltip.vue'

export default {
  name: 'wy-smart-tag-dashboard-page-header',
  props: ['controller', 'tableRef'],
  data() {
    return {
      selectAll: false,
      searchFields: [
        { label: 'AI Tag Name', name: 'smartTagName' },
        { label: 'AI Tag Category', name: 'smartTagCategory' },
      ]
    }
  },
  components: {
    'wy-table-column': WyTableColumn,
    'wy-table-search': WyTableSearch,
    // 'wy-page-tooltip': wyPageTooltip
  },

  computed: {
    ...mapGetters(['dataModel', 'tableModel', 'isRoleAllow', 'currentPageInfo', 'authUser']),

    enableExport() {
      return  this.controller && this.controller.tableModel && this.controller.tableModel.selectedRows && this.controller.tableModel.selectedRows.length > 0;
    },
    hideSearchColumnUI() {
      let available = true;
      if (this.tableModel && this.tableModel.results && this.tableModel.results.length == 0) {
        available = false;
      }
      return !available;
    }
  },

  methods: {

    async handleExport() {
      const selectedColumns = this.controller.dataModel.columns.slice(2).filter(column => column.selected);
      const allRows = this.controller.$refs.tableData;
      let selectedRows = this.controller.tableModel.selectedRows;
      
      const noSelectedRows = selectedRows.length == 0;
      if (noSelectedRows) {
        selectedRows = allRows;
      }

      let exportResult = []
      let exportRow = {}
      let sentimentValue;
      let value = "N/A"

      selectedRows.map(row => {
        exportRow["AI Tag Name"] = row["smartTagName"]
        selectedColumns.map((column, index) => {
          const columnName = `${column.group} ${column.label}`;
          const columnValue = row[column.name];

          if (columnName.includes("%")) {
            value = `${Number(columnValue).toLocaleString()}%`
          } else if (typeof columnName == "number") {
            value = Number(columnValue).toLocaleString()
          } else { // string type
            value = columnValue
          }

          // Sentiment % Change ColumnName is the same for all 3 sentiments
          // ColumnName: "% change from last period"
          if (columnName.includes("Sentiment %")) {
            if (selectedColumns[index - 1].label == "Positive") sentimentValue = "Positive";
            if (selectedColumns[index - 1].label == "Neutral") sentimentValue = "Neutral";
            if (selectedColumns[index - 1].label == "Negative") sentimentValue = "Negative";
            if (columnValue == null || columnValue == -1) {
              return exportRow[`${columnName}-${sentimentValue}`] = "N/A";
            }
            return exportRow[`${columnName}-${sentimentValue}`] = value;
          }

          if (columnValue == null || columnValue == -1) {
            return exportRow[columnName] = "N/A";
          }
          else {
            this.dataModel.columns.forEach(el => {
              if (el.name == column.name && el.selected == true) {
                if (typeof value == 'string') {
                  exportRow[columnName] = value.replace(/(<([^>]+)>)/ig, '');
                }
                else {
                  exportRow[columnName] = value;
                }
              }
            })
          }

          delete exportRow["Volume Trend"]
        });
        exportResult.push(exportRow);
        exportRow = {};
      });

      const csv = new ObjectsToCsv(exportResult);
      const csvContent = await csv.toString();
      //let csvContent = csvHeaders + WyUtils.convertObjToCSV(exportItems);
      let exportedFilenmae = `${this.authUser.company.name.replace(/ /g, "_")}_AI_Generated_Tags_${this.dataModel.dateStart}_to_${this.dataModel.dateEnd}.csv`;
      let blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      let downloadLink = document.createElement("a");
      if (downloadLink.download !== undefined) {
        let url = URL.createObjectURL(blob);
        downloadLink.setAttribute("href", url);
        downloadLink.setAttribute("download", exportedFilenmae);
        downloadLink.style.visibility = 'hidden';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    }
  },

  mounted() {
    this.$root.$on(`select-all-change-events`, bool => {
      this.selectAll = bool;
    })
  }
}
</script>

<style lang="scss">
.contact-reason-compare-metrics {
  cursor: pointer;
  background-image: url('../../assets/icons/icon_comparison.svg') !important;
  background-repeat: no-repeat;
  background-position-y: 10px;
  background-position-x: 25px;
  padding-left: 60px;
  display: flex;
  align-items: center;
  height: 45px;
  border: 0px;
  background-color: transparent;
}

.action-dropdown {
  position: absolute;
  left: 346px;
  border: 1px solid #CAD2DA;
  padding: 0px 11px;
  color: #202223;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 29px;
  margin-left: 10px;
}

.actionDropdown {
  width: 320px;
  left: 676px !important;

  .el-dropdown-menu__item.is-disabled {
    opacity: 0.5;
  }
}

.contact-reason-merge-topic {
  cursor: pointer;
  background-image: url('../../assets/icons/icon_merged.svg') !important;
  background-repeat: no-repeat;
  background-position-y: 10px;
  background-position-x: 25px;
  display: flex;
  align-items: center;
  padding-left: 60px;
  height: 45px;
  border: 0px;
  background-color: transparent;
}

.wy-smart-tag-dashboard-page-header {
  .wy-page-tooltip .info-icon {
    right: 6px;
    top: -4px;
  }

  td.col3.table-header-middle {
    // border: 1px solid #CAD2DA;
    display: flex;
    justify-content: space-between;
    height: 60px;
    width: calc(100% + 2px);
    padding: 18px 0px 11px 0px;
    background-color: #FFF;
    border-top: unset;
    align-items: center;
    > div {
      position: relative;
    }
    .search-label-prefix {
      position: absolute;
      left: 33px;
      font-size: 14px;
      color: #4A4A4F;
    }
  }

  .table-header {
    border: 1px solid #CAD2DA;
    height: 60px;
    background-color: #FFF;
    color: var(--site-font-secondary-color);
    font-weight: 500;
    display: flex;
    font-size: 20px;
    width: calc(100% + 2px);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin-top: 20px;
    align-items: center;
  }

  >table {
    width: 100%;

    .col3 {
      text-align: right;
      display: flex;
      float: right;

      .export-btn {
        box-sizing: border-box;
        border-radius: 5px;
        background: var(--site-button-secondary-btn-background-primary-color);
        color: var(--site-button-secondary-btn-text-primary-color) !important;
        border: 1px solid var(--site-button-secondary-btn-hover-border-primary-color);
        padding: 6px 15px 9px 11px !important;
        width: 90px;
        font-size: 16px !important;
        font-weight: 500 !important;
        height: 35px;
        float: right;
        margin-left: 20px;;
        margin-top: 0px;
      }

      .export-btn:hover {
        border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
        background-color: var(--site-button-secondary-btn-hover-background-primary-color) !important;
        border-radius: 5px;
        color: var(--site-button-secondary-btn-text-primary-color) !important;
      }
      .export-btn:active {
        background-color: var(--site-button-secondary-btn-pressed-background-primary-color) !important;
      }
      .export-btn:focus {
        border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
        border-radius: 5px;
        color: var(--site-button-secondary-btn-text-primary-color) !important;
      }
      .export-icon {
        background: var(--icon_action_export);
        height: 17px;
        width: 13px;
        position: relative;
        top: 2px;
        height: 17px;
        width: 13px;
        display: inline-block;
        background-repeat: no-repeat;
      }
      .export-text {
        position: relative;
        bottom: 1px;
        left: 5px;
      }
    }
  }

  // .list-header {
  //   margin-bottom: 8px;
  // }

  .list-header-group {
    display: inline-flex;
  }

  .small-title {
    color: #909096;
    font-size: 15px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 400;
    padding-top: 5px;
    position: relative;
    top: 2px;
  }

  .title {    
    color: var(--site-font-secondary-color);
    font-size: 25px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 600;
    width: 286px;
    line-height: 0.7;
  }

  .column-filter {
    height: 34px;
    display: inline-block;
  }

  .question-mark {
    display: inline-block;
    width: 20px;
    padding-top: 3px;
    margin-left: 0px;

    .el-question-mark {
      cursor: pointer;
      // background-image: url('../../assets/icons/info_hover.svg');
      // background-size: 80%;
      // background-repeat: no-repeat;
      // background-position-y: 0px;
      color: #214586;
      height: 30px;
      border-radius: 1px;
      border: 0px;
      padding: 2px 5px 8px 5px;
      background-color: transparent;
    }

    .el-question-mark:hover {
      color: #214586;
      // background-image: url('../../assets/icons/info_hover.svg');
      // background-color: unset;
    }

    .el-button:focus,
    .el-button:hover {
      background-color: transparent;
    }
  }

  .el-button {
    padding: 10px 15px 20px 15px;
    margin-left: 0px;
    margin-right: 0px;
  }
}

.div-icons {
  display: inline-block;
  padding-left: 8px;
}

.contact-reason-question-pop-over {
  word-break: keep-all;

  .popper__arrow {
    display: block !important;
  }
}

.el-popover {
  padding: 30px;
  text-align: left;
}
</style>
